// Generated by Melange

import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import InfoSvg from "static/icons/info.svg";

function ItemFormConstructor$ToolTip(Props) {
  let content = Props.content;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(InfoSvg, {})
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                            className: "text-white",
                            children: content
                          }),
                      className: "absolute hidden bg-asphalt-dark p-2 rounded-md w-36 group-hover:block z-2"
                    })
              ],
              className: "relative group"
            });
}

const ToolTip = {
  make: ItemFormConstructor$ToolTip
};

function make(className) {
  return function (children) {
    return JsxRuntime.jsx("div", {
                children: children,
                className: Cn.fromList({
                      hd: "grid grid-cols-item-form gap-x-4 gap-y-1 items-center pt-4",
                      tl: {
                        hd: Cn.take(className),
                        tl: /* [] */0
                      }
                    })
              });
  };
}

function ItemFormConstructor$Grid(Props) {
  return make(Props.className)(Props.children);
}

const Grid = {
  make: ItemFormConstructor$Grid
};

const _map = {"small":"small","medium":"medium","large":"large"};

function sizeToJs(param) {
  return param;
}

function sizeFromJs(param) {
  return _map[param];
}

function make$1(name) {
  return function (value) {
    return function (tooltipContent) {
      return function (sizeOpt) {
        const size = sizeOpt !== undefined ? sizeOpt : "small";
        return JsxRuntime.jsxs(React.Fragment, {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    children: name
                                  }),
                              tooltipContent !== undefined ? JsxRuntime.jsx(ItemFormConstructor$ToolTip, {
                                      content: tooltipContent
                                    }) : null
                            ],
                            className: "col-start-1 col-end-2 justify-between"
                          }),
                      JsxRuntime.jsx("div", {
                            children: value,
                            className: Cn.fromList({
                                  hd: "col-start-2",
                                  tl: {
                                    hd: size === "medium" ? "col-end-14 sm:col-end-12 md:col-end-6" : (
                                        size === "small" ? "col-end-14 sm:col-end-10 md:col-end-4" : "col-end-14 sm:col-end-12 md:col-end-8"
                                      ),
                                    tl: /* [] */0
                                  }
                                })
                          })
                    ]
                  });
      };
    };
  };
}

function ItemFormConstructor$SectionItem(Props) {
  return Curry._2(make$1(Props.name)(Props.value), Props.tooltipContent, Props.size);
}

const SectionItem = {
  sizeToJs: sizeToJs,
  sizeFromJs: sizeFromJs,
  make: ItemFormConstructor$SectionItem
};

export {
  ToolTip ,
  Grid ,
  SectionItem ,
}
/* Buhta_components__Text Not a pure module */
